import { render, staticRenderFns } from "./AppExpansionPanelGroups.vue?vue&type=template&id=a8d91be4&"
import script from "./AppExpansionPanelGroups.vue?vue&type=script&lang=ts&"
export * from "./AppExpansionPanelGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports